import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { addEventListener } from '../utils/dom/document';
import { getParent } from '../utils/dom/element';
import { isMacOS, isFirefox } from '../utils/is';
import ready from '../utils/dom/ready';
import { tableClass } from './styles';
var selectClass = tableClass('select');
var trClass = tableClass('normal');
var noSelection = tableClass('no-selection'); // event combination

function _isEventCombination(event) {
  var ismo = isMacOS();
  return ismo && event.metaKey || !ismo && event.ctrlKey;
} // 根据table tr层次   合并td


function mergeDomsText(nodes) {
  if (!nodes || nodes.length <= 0) return [];
  var trs = [];
  var res = [];
  nodes.forEach(function (node) {
    var tr = getParent(node, "tr.".concat(trClass));
    var index = trs.indexOf(tr);

    if (index === -1) {
      trs.push(tr);
      index = trs.length - 1;
    }

    if (res[index]) {
      res[index].push(node.innerText);
    } else {
      res[index] = [node.innerText];
    }
  });
  return res;
} // format table text
// 组合 text


function formatTableText(arrs) {
  if (!arrs || arrs.length <= 0) return '';
  var txt = '';
  arrs.forEach(function (value) {
    if (typeof value === 'string') {
      txt += "".concat(value, "\t");
    } else {
      txt += "".concat(formatTableText(value), "\n");
    }
  });
  return txt;
} // 生成 textarea，并且执行 copy


function execCopyCommand(text) {
  // if none, return;
  if (!text) return;
  var textarea = document.createElement('textarea');
  textarea.setAttribute('readonly', 'readonly');
  textarea.value = text; // out window

  textarea.style.position = 'fixed';
  textarea.style.top = '-9999px';
  textarea.style.left = '-9999px';
  document.body.append(textarea);
  textarea.select();

  if (document.execCommand('copy')) {
    document.execCommand('copy');
  }

  if (textarea && textarea.parentNode) textarea.parentNode.removeChild(textarea);
} // remove all selectClass from dom


function removeSelectClass(dom) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (dom) {
    dom.classList.remove(selectClass);
    return;
  }

  if (force) return;
  var nodes = document.querySelectorAll(".".concat(selectClass));
  if (nodes.length <= 0) return;
  nodes.forEach(function (elem) {
    removeSelectClass(elem);
  });
  var node = document.querySelector(".".concat(noSelection));
  if (node) node.classList.remove(".".concat(noSelection));
} // add selection class


function addSelectionClass(dom) {
  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : selectClass;
  if (!dom) return;
  dom.classList.add(className);
}

function toggleNoSelection(flag) {
  if (flag) {
    document.body.classList.add(noSelection);
    return;
  }

  document.body.classList.remove(noSelection);
} // handle document click


function docClick(event) {
  var target = event.target;
  if ((getParent(target, ".".concat(tableClass('simple-body'))) || getParent(target, ".".concat(tableClass('body')))) && _isEventCombination(event)) return;
  removeSelectClass();
  toggleNoSelection();
} // 批量操作
// bulk operation doms


function bulkOperation(doms, start, end) {
  if (!doms || doms.childNodes.length <= 0 || start <= -1 || end <= -1) return;
  var arr = Array.prototype.slice.call(doms.childNodes, start, end + 1);
  arr.forEach(function (dom) {
    addSelectionClass(dom);
  });
} // 批量操作 -->  添加 selection classname


function bulkAddSelectionClass(td, cache) {
  var tr = getParent(td, "tr.".concat(trClass));
  if (!tr) return;
  var trs = tr.parentNode.childNodes;
  var xIndex = Array.prototype.indexOf.call(tr.childNodes, td);
  var count = 0; // xIndex - cache.xIndex

  while (count < trs.length) {
    if (cache.yIndex <= count) {
      var Atr = trs[count];
      bulkOperation(Atr, cache.xIndex, xIndex);
    }

    if (trs[count] === tr) {
      break;
    }

    count += 1;
  }
}

function handleKeyDown(event) {
  if (!_isEventCombination(event) || event.keyCode !== 67) return;
  var texts = formatTableText(mergeDomsText(document.querySelectorAll(".".concat(selectClass))));
  execCopyCommand(texts);
} // ctrl + c


ready(function () {
  addEventListener(document, 'keydown', handleKeyDown);
});
export default (function (Table) {
  var _temp;

  return _temp =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(_temp, _React$Component);

    var _super = _createSuper2(_temp);

    function _temp(props) {
      var _this;

      _classCallCheck(this, _temp);

      _this = _super.call(this, props);
      _this.doc = void 0;
      _this.isFirefox = void 0;
      _this.events = void 0;
      _this.move = void 0;
      _this.cache = void 0;
      _this.prevDom = void 0;
      _this.doc = null;
      _this.isFirefox = isFirefox();
      _this.events = {};
      _this.move = false;
      _this.cache = {};
      _this.prevDom = null;
      _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
      _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
      _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_this));

      if (!_this.isFirefox && _this.selection) {
        _this.events.onMouseDown = _this.handleMouseDown;
        _this.events.onMouseUp = _this.handleMouseUp;
        _this.events.onMouseMove = _this.handleMouseMove;
      }

      return _this;
    }

    _createClass(_temp, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!this.isFirefox && this.selection) {
          this.doc = addEventListener(document, 'click', docClick);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.doc) {
          this.doc.remove();
        }
      }
    }, {
      key: "isEventCombination",
      value: function isEventCombination(event) {
        return this.selection && _isEventCombination(event);
      }
    }, {
      key: "handleMouseDown",
      value: function handleMouseDown(event) {
        if (!this.isEventCombination(event)) return;
        toggleNoSelection(true); // toggle move

        this.move = true;
        var td = getParent(event.target, 'td');
        var tr = getParent(td, "tr.".concat(trClass));
        this.prevDom = td;
        if (!tr) return;
        var xIndex = Array.prototype.indexOf.call(tr.childNodes, td);
        var yIndex = Array.prototype.indexOf.call(tr.parentNode.childNodes, tr);
        this.cache.xIndex = xIndex;
        this.cache.yIndex = yIndex;
        this.cache.dom = td;
      }
    }, {
      key: "handleMouseUp",
      value: function handleMouseUp(event) {
        if (!this.isEventCombination(event)) return;
        var target = event.target;
        var td = getParent(target, 'td');

        if (td === this.cache.dom) {
          this.cache = {};
          this.move = false;

          if (td.classList.contains(selectClass)) {
            removeSelectClass(td);
            return;
          }

          addSelectionClass(td);
          return;
        }

        this.prevDom = null;
        bulkAddSelectionClass(td, this.cache); // reset

        this.cache = {};
        this.move = false;
      }
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove(event) {
        if (!this.move) return;
        var td = getParent(event.target, 'td');
        if (this.prevDom === td) return;
        this.prevDom = td; // clear class name

        removeSelectClass();
        bulkAddSelectionClass(td, this.cache);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            selection = _this$props.selection,
            cellSelectable = _this$props.cellSelectable,
            otherProps = _objectWithoutProperties(_this$props, ["selection", "cellSelectable"]);

        return (
          /*#__PURE__*/
          React.createElement(Table, Object.assign({}, otherProps, {
            events: this.events
          }))
        );
      }
    }, {
      key: "selection",
      get: function get() {
        var _this$props2 = this.props,
            selection = _this$props2.selection,
            cellSelectable = _this$props2.cellSelectable;
        return selection || cellSelectable;
      }
    }]);

    return _temp;
  }(React.Component), _temp;
});